import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-title"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["data-title"]
const _hoisted_4 = ["src", "alt"]

import { RouteLocationRaw, RouterLink } from 'vue-router';
import { toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PopularDestinationItemComponent',
  props: {
    link: null,
    image: null,
    title: null,
    asButton: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  link?: RouteLocationRaw,
  image: string,
  title: string,
  asButton?: boolean,
}



const { link, image, title, asButton = false } = toRefs(props);


return (_ctx: any,_cache: any) => {
  return (_unref(asButton))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "b-popular-destination border-radius",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClick')))
      }, [
        _createElementVNode("div", {
          class: "image",
          "data-title": _unref(title)
        }, [
          _createElementVNode("img", {
            src: _unref(image),
            alt: _unref(title)
          }, null, 8, _hoisted_2)
        ], 8, _hoisted_1)
      ]))
    : (_openBlock(), _createBlock(_unref(RouterLink), {
        key: 1,
        class: "b-popular-destination border-radius",
        to: _unref(link)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "image",
            "data-title": _unref(title)
          }, [
            _createElementVNode("img", {
              src: _unref(image),
              alt: _unref(title)
            }, null, 8, _hoisted_4)
          ], 8, _hoisted_3)
        ]),
        _: 1
      }, 8, ["to"]))
}
}

})